import React, { useState } from "react";
import { IObjectiveData } from "../../exports/interfaces";
import { Fade } from "react-awesome-reveal";

const AboutObjective = (props: {
  keyObjectivesData: IObjectiveData[];
  objectivesTrustData: IObjectiveData[];
}) => {
  const [activeTab, setActiveTab] = useState<string>("key");

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <section className="quality-work" style={{padding: '0px 0px 90px 0px'}}>
      {/* <div
        className="quality-work-shape"
        style={{
          backgroundImage: `url(assets/images/shapes/quality-work--shape.png)`,
        }}
      ></div> */}
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="quality-work__tab-box tabs-box">
              <ul className="tab-buttons clearfix list-unstyled">
                <li
                  className={`tab-btn ${
                    activeTab === "key" ? "active-btn" : ""
                  }`}
                  onClick={() => handleTabChange("key")}
                >
                  <span>Key Objectives</span>
                </li>
                <li
                  className={`tab-btn ${
                    activeTab === "trust" ? "active-btn" : ""
                  }`}
                  onClick={() => handleTabChange("trust")}
                >
                  <span>Objectives Of The Trust</span>
                </li>
              </ul>

              <div className="tabs-content">
                {activeTab === "key" && (
                  <div className="tab active-tab animated fadeInUp">
                    <div className="tab-content__inner">
                      <div className="row">
                        <div className="col-xl-12">
                          <ul className="about-one__points list-unstyled">
                            {props?.keyObjectivesData?.map((data) => (
                              <Fade cascade damping={0.2} triggerOnce={true}>
                                <li
                                  // style={{ paddingBottom: "20px" }}
                                  key={data.id}
                                >
                                  <div className="text custom-text">
                                    <div className="icon">
                                      <span
                                        className="icon-confirmation icon"
                                        style={{ fontSize: "21px" }}
                                      ></span>
                                    </div>
                                    <p style={{ textAlign: "justify" }}>
                                      {data?.attributes?.Objective}
                                    </p>
                                  </div>
                                </li>
                              </Fade>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "trust" && (
                  <div className="tab active-tab animated fadeInUp">
                    <div className="tab-content__inner">
                      <div className="row">
                        <div className="col-xl-12">
                          <ul className="about-one__points list-unstyled">
                            {props?.objectivesTrustData?.map((data) => (
                              <Fade cascade damping={0.2} triggerOnce={true}>
                                <li
                                  // style={{ paddingBottom: "20px" }}
                                  key={data.id}
                                >
                                  <div className="text custom-text"> 
                                    <div className="icon">
                                      <span
                                        className="icon-confirmation icon"
                                        style={{ fontSize: "21px" }}
                                      ></span>
                                    </div>
                                    <p style={{ textAlign: "justify" }}>
                                      {data?.attributes?.Objective}
                                    </p>
                                  </div>
                                </li>
                              </Fade>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutObjective;
